import { Grid } from '@mui/material';

import { FormAutocompleteField, FormNumberField } from '../../../../../../common';
import { CHILD_DELIVERY_TYPE_OPTIONS, MEDICAL_NUMERIC_FIELD_BOUNDS } from '../constants';

import type { MedicalFieldsProps } from './types';

export default function BirthInfoFields({ formik, disabled, saveFieldOnBlur }: MedicalFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Child delivery type"
          name="child_delivery_type"
          onChange={saveFieldOnBlur}
          options={CHILD_DELIVERY_TYPE_OPTIONS}
          placeholder="Select type of delivery"
          required
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Child's Gestational age at Birth (weeks)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_gestational_age.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_gestational_age.min}
          name="child_gestational_age"
          onBlur={saveFieldOnBlur}
          placeholder="wks"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Weight at birth (pounds)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_weight_at_birth_pounds.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_weight_at_birth_pounds.min}
          name="child_weight_at_birth_pounds"
          onBlur={saveFieldOnBlur}
          placeholder="lbs"
          required
        />
      </Grid>
      <Grid item xs={6} sm={3}>
        <FormNumberField
          disabled={disabled}
          formik={formik}
          label="Weight at birth (ounces)"
          max={MEDICAL_NUMERIC_FIELD_BOUNDS.child_weight_at_birth_ounces.max}
          min={MEDICAL_NUMERIC_FIELD_BOUNDS.child_weight_at_birth_ounces.min}
          name="child_weight_at_birth_ounces"
          onBlur={saveFieldOnBlur}
          placeholder="ozs"
          required
        />
      </Grid>
    </Grid>
  );
}
